/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to initialize chunk upload.
 * @export
 * @interface ChunksInitRequest
 */
export interface ChunksInitRequest {
    /**
     * Visit form draft UUID
     * @type {string}
     * @memberof ChunksInitRequest
     */
    draftId: string;
    /**
     * Form section number
     * @type {number}
     * @memberof ChunksInitRequest
     */
    sectionNumber: number;
    /**
     * Media category
     * @type {string}
     * @memberof ChunksInitRequest
     */
    mediaType: string;
    /**
     * Original filename
     * @type {string}
     * @memberof ChunksInitRequest
     */
    filename: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof ChunksInitRequest
     */
    contentType: string;
    /**
     * Total number of chunks to be uploaded
     * @type {number}
     * @memberof ChunksInitRequest
     */
    totalParts: number;
}

/**
 * Check if a given object implements the ChunksInitRequest interface.
 */
export function instanceOfChunksInitRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "draftId" in value;
    isInstance = isInstance && "sectionNumber" in value;
    isInstance = isInstance && "mediaType" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "totalParts" in value;

    return isInstance;
}

export function ChunksInitRequestFromJSON(json: any): ChunksInitRequest {
    return ChunksInitRequestFromJSONTyped(json, false);
}

export function ChunksInitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunksInitRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'draftId': json['draft_id'],
        'sectionNumber': json['section_number'],
        'mediaType': json['media_type'],
        'filename': json['filename'],
        'contentType': json['content_type'],
        'totalParts': json['total_parts'],
    };
}

export function ChunksInitRequestToJSON(value?: ChunksInitRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'draft_id': value.draftId,
        'section_number': value.sectionNumber,
        'media_type': value.mediaType,
        'filename': value.filename,
        'content_type': value.contentType,
        'total_parts': value.totalParts,
    };
}

